<div class="simple-mode-container">
  <!-- Galeria de Templates -->
  <div class="section">
    <h3 class="section-title">
      <nz-icon nzType="appstore" nzTheme="outline"></nz-icon>
      Selecione um Comportamento
    </h3>
    <app-template-gallery
      [templates]="availableTemplates"
      [selectedTemplate]="selectedTemplate"
      (templateSelected)="onTemplateSelected($event)">
    </app-template-gallery>
  </div>

  <!-- Configurador do Template -->
  <div class="section" *ngIf="selectedTemplate">
    <h3 class="section-title">
      <nz-icon nzType="setting" nzTheme="outline"></nz-icon>
      Configure o Comportamento
    </h3>
    <app-template-configurator
      [template]="selectedTemplate"
      [canvasContext]="canvasContext"
      (configChanged)="onConfigChanged($event)">
    </app-template-configurator>
  </div>

  <!-- Preview do Comportamento -->
  <div class="section" *ngIf="selectedTemplate">
    <h3 class="section-title">
      <nz-icon nzType="eye" nzTheme="outline"></nz-icon>
      Preview
    </h3>
    <app-behavior-preview
      [template]="selectedTemplate"
      [config]="templateConfig"
      [eventConfig]="generatedEventConfig">
    </app-behavior-preview>
  </div>
</div>



